import dayjs from "dayjs";
import {
	FieldValues,
	UseControllerProps,
	useController
} from "react-hook-form";

type StackDirection = "row" | "column";

export interface MonthPickerProps<
	T extends FieldValues
> extends UseControllerProps<T> {
	months?: string[];

	shortMonth?: boolean;

	direction?: StackDirection;
}

const MonthPicker = <T extends FieldValues>({
	months = [],
	shortMonth = false,
	direction = "row",
	...controllerProps
}: MonthPickerProps<T>) => {
	const {
		field: { name, ref, value, onBlur, onChange }
	} = useController(controllerProps);

	if (months.length === 0) {
		months = Array.from({ length: 12 }, (_, index) =>
			dayjs()
				.month(index)
				.format(shortMonth ? "MMM" : "MMMM")
		);
	}

	const selectId = `month-picker-${name}`;

	return (
		<div className="w-full">
			<div>
				<div
					className={`flex ${direction === "row" ? "flex-row items-center" : "flex-col"}`}
				>
					<label
						htmlFor={selectId}
						className="font-normal m-0 whitespace-nowrap"
					>
						Month:
					</label>

					<select
						id={selectId}
						name={name}
						ref={ref}
						value={value ?? ""}
						onBlur={onBlur}
						onChange={onChange}
						className="w-full px-3 py-2 bg-white border border-border rounded-lg text-base focus:outline-none focus:ring-1 focus:ring-ring"
					>
						{months.map((month) => (
							<option key={month}>{month}</option>
						))}
					</select>
				</div>
			</div>
		</div>
	);
};

export default MonthPicker;
